export const locale = {
    Loading: {
        Waiting: "لطفا صبر کنید",
        Description: "چند لحظه صبر کنید"
    },
    Questions: {
        Yes: "بله",
        No: "خیر"
    },
    Success: {
        Title: "موفقیت آمیز",
        defaultActionText: "متوجه شدم"
    },
    Info: {
        Title: "اطلاع رسانی",
        defaultActionText: "متوجه شدم"
    },
    Warning: {
        Title: "توجه",
        defaultActionText: "متوجه شدم"
    },
    Error: {
        Title: "خطا",
        defaultActionText: "متوجه شدم"
    },
    Wallet: {
        Title: "موجوی ناکافی",
        defaultActionText: "متوجه شدم"
    },
    ConnectionLost: {
        Title: "اینترنت شما قطع شده است",
        Subtitle: "لطفا از اتصال اینترنت خود مطمئن شوید",
        Button: "تلاش مجدد"
    }
}